import React from 'react';
import { Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import PrivateRouteAdmin from '../../routing/PrivateRoute';
import PageHighlightInfo from './info';
import PageHighlightPosts from './posts';

const PageHighlightRouter = ({ match }) => (
  <Switch>
    <PrivateRouteAdmin exact path={`${match.path}`} component={PageHighlightInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/posts`} component={PageHighlightPosts} />
  </Switch>
);

PageHighlightRouter.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default PageHighlightRouter;
